import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69a779034fab3d001400cb14_1785432539271_17ecaf2d/efoilexperience/src/app/it/efoil-boards/page.tsx");
